/**
 * Navigation utilities
 *
 * Use `hardRedirect` for:
 * - Cross-domain redirects (SSO, external sites)
 * - Hard logout resets (if required)
 *
 * Use React Router's `navigate()` for all internal routes.
 */

/**
 * Use only for cross-domain or hard reset scenarios
 */
export const hardRedirect = (url: string): void => {
    window.location.href = url;
};
